import React, { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';

import { recordPageView } from '@occc-app/lib/GoogleAnalytics';

type Props = { children?: React.ReactNode; onUpdate: typeof recordPageView };

const RouteTracker: React.FC<Props> = ({ onUpdate }) => {
  const location = useLocation();
  useEffect(() => {
    onUpdate(location.pathname);
  }, [location.pathname, onUpdate]);
  return null;
};

const Router: React.FC<Props> = ({ onUpdate, children }) => {
  return (
    <NuqsAdapter>
      <BrowserRouter>
        <RouteTracker onUpdate={onUpdate} />
        {children}
      </BrowserRouter>
    </NuqsAdapter>
  );
};

export default Router;
